import { Cell, Row } from "@tanstack/react-table";
import { useEffect, useState } from "react";

import { useTableContext } from "../../context";
import { useCellEdit } from "./use-cell-edit";

export default function CellInput<T>({
  row,
  cell,
}: {
  row: Row<T>;
  cell: Cell<T, unknown>;
}) {
  const { table } = useTableContext();

  const updateData = table?.options?.meta?.updateData;
  const isUpdating = table?.options?.meta?.isUpdating ?? false;
  const columnId = cell.column?.id;
  const cellValue = cell.getValue() as string | number | undefined;

  const [value, setValue] = useState(cellValue);

  useEffect(() => {
    setValue(cellValue);
  }, [cellValue]);

  const { controlProps } = useCellEdit<T, HTMLInputElement>({
    row,
    cell,
    isChanged: () => value !== cellValue,
    commit: () => {
      try {
        updateData?.(row, columnId, value);
      } catch (error) {
        console.error(error);
        setValue(cellValue);
      }
    },
    restore: () => setValue(cellValue),
    describeValue: () => String(value ?? ""),
  });

  return (
    <input
      {...controlProps}
      value={value}
      onChange={(event) => {
        const newValue = event.target.value;
        setValue(newValue);
      }}
      disabled={isUpdating}
      className="w-full h-target px-2 py-1 border border-default rounded-sm focus:outline-none focus:ring-1 focus:ring-focus focus:border-focus disabled:bg-surface disabled:cursor-not-allowed"
    />
  );
}
